"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarknetContractConnector = exports.FEE_MULTIPLIER = void 0;
const axios_1 = __importDefault(require("axios"));
const starknet_1 = require("starknet");
const WAIT_FOR_TRANSACTION_TIME_INTERVAL = 30103;
exports.FEE_MULTIPLIER = 1000000000000000000;
class StarknetContractConnector {
    constructor(account, contractAddress, abi, network = "goerli-alpha") {
        this.contractAddress = contractAddress;
        this.abi = abi;
        this.network = network;
        this.provider =
            account || new starknet_1.Provider({ sequencer: { network: this.network } });
    }
    async waitForTransaction(txHash) {
        const result = await this.provider.waitForTransaction(txHash, WAIT_FOR_TRANSACTION_TIME_INTERVAL, ["ACCEPTED_ON_L2", "REJECTED"]);
        console.log(`Transaction ${txHash} finished with status: ${result.status}, fee: ${result.actual_fee != undefined
            ? parseInt(result.actual_fee) / exports.FEE_MULTIPLIER
            : result.actual_fee} ETH`);
        return result.status == "ACCEPTED_ON_L2";
    }
    getContract() {
        return new starknet_1.Contract(this.abi, this.contractAddress, this.provider);
    }
    async getBlockNumber(rpcUrl) {
        const response = await axios_1.default.post(rpcUrl, {
            jsonrpc: "2.0",
            method: "starknet_blockNumber",
            params: [],
            id: 1,
        });
        return response.data.result;
    }
}
exports.StarknetContractConnector = StarknetContractConnector;
//# sourceMappingURL=StarknetContractConnector.js.map